import { Language } from '../../entities';

export enum UpdateClassification {
  Critical = 'Critical',
  Major = 'Major',
  Minor = 'Minor'
}

export type Version = {
  id: number;
  value: string;
};

export interface VersionNumber {
  cpNumber: number;
  hardwareId: number;
  major: number;
  minor: number;
  develop: number;
}

interface FileInfo {
  fileName: string;
  fileSizeInBytes: number;
}

export type PackageStatus = 'Draft' | 'Released' | 'Withdrawn' | 'Unknown';

export interface BackendFirmwarePackageDetailsDto {
  id: number;
  versionNumber: VersionNumber;
  manifest: string;
  distribution: {
    access: string;
    supportedCompanionApps: {
      name: string;
      appleMinimumVersion: string;
      androidMinimumVersion: string;
    }[];
  };
  compatibleVersions: VersionNumber[];
  packageMetadata: {
    classification: string;
    packageName: string;
  };
  fileInfo: FileInfo;
  packageStatus: PackageStatus;
  possibleActions: string[];
  releaseNotes: Language[];
}

// the interface below is used in the edit mode section

export interface FrontendFirmwarePackageDetails {
  packageMetadata: {
    classification: string;
    packageName: string;
  };
  distribution: {
    access: string;
    supportedCompanionApps: {
      name: string;
      appleMinimumVersion: string;
      androidMinimumVersion: string;
    }[];
  };
  deviceCompatibility: {
    compatible_device_software_versions: string[];
  };
  fileUpload: {
    fileName: string;
    fileSize: number;
  };
  manifestInfo: {
    manifest: string;
  };
  releaseNotes: {
    notes: { [languageCode: string]: string };
  };
  packageStatus: string;
}

export type HistoryEvent = 'Created' | 'Modified' | 'Released' | 'Withdrawn';

export interface PackageChangeHistoryDto {
  event: HistoryEvent;
  user: string;
  timestamp: number;
  remarks: string | null;
}

export interface MapToPackageUploadMetadataType {
  deviceCompatibility: {
    compatible_device_software_versions: { id: number; value: string }[];
    isValid: boolean;
  };
  distribution: {
    access: string;
    supportedCompanionApps: {
      name: string;
      appleMinimumVersion: string;
      androidMinimumVersion: string;
    }[];
    isValid: boolean;
  };
  packageMetadata: {
    classification: string;
    packageName: string;
    isValid: boolean;
  };
  releaseNotes: {
    release_notes: string;
    isValid: boolean;
  };
}
